import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BrandLogo from './BrandLogo';
import './Navbar.css';

function NavAvatar({ user }) {
  const initiales = user?.nom
    ? user.nom.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()
    : '?';
  return (
    <div className="nav-avatar">
      {user?.avatar
        ? <img src={user.avatar} alt={user.nom} />
        : <span>{initiales}</span>
      }
    </div>
  );
}

function MobileIcon({ type }) {
  const common = {
    width: 20,
    height: 20,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };
  const icons = {
    home: <><path d="M3 11l9-8 9 8"/><path d="M5 10v10h14V10"/><path d="M9 20v-6h6v6"/></>,
    search: <><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></>,
    needs: <><path d="M4 5h16v12H8l-4 4V5z"/><path d="M8 9h8"/><path d="M8 13h5"/></>,
    plus: <><circle cx="12" cy="12" r="9"/><path d="M12 8v8"/><path d="M8 12h8"/></>,
    user: <><circle cx="12" cy="8" r="4"/><path d="M4 21c1.8-4 4.5-6 8-6s6.2 2 8 6"/></>,
    menu: <><path d="M4 6h16"/><path d="M4 12h16"/><path d="M4 18h16"/></>,
    login: <><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><path d="M10 17l5-5-5-5"/><path d="M15 12H3"/></>,
    register: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M19 8v6"/><path d="M16 11h6"/></>,
  };
  return <svg {...common}>{icons[type] || icons.menu}</svg>;
}

export default function Navbar() {
  const { user, deconnexion } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOuvert, setMenuOuvert] = useState(false);

  useEffect(() => { setMenuOuvert(false); }, [location]);

  const handleDeconnexion = () => {
    deconnexion();
    navigate('/');
  };

  return (
    <>
      <nav className="navbar">
        <div className="container navbar-inner">
          <Link to="/" className="navbar-logo">
            <BrandLogo height={46} />
          </Link>

          {!user && (
            <div className="nav-auth-quick">
              <Link to="/connexion" className="nav-aq-connexion">Connexion</Link>
              <Link to="/inscription" className="nav-aq-inscrire">S'inscrire</Link>
            </div>
          )}

          <button className={`burger ${menuOuvert ? 'actif' : ''}`} onClick={() => setMenuOuvert(!menuOuvert)} aria-label="Menu" aria-expanded={menuOuvert}>
            <span /><span /><span />
          </button>

          <div className={`navbar-links ${menuOuvert ? 'ouvert' : ''}`}>
            <NavLink to="/">Annonces</NavLink>
            <NavLink to="/besoins">Demandes</NavLink>
            <NavLink to="/agences">Agences</NavLink>
            <NavLink to="/diaspora">Diaspora</NavLink>
            <NavLink to="/tarifs">Tarifs</NavLink>

            {user ? (
              <>
                {user.role === 'admin' && <NavLink to="/admin">Administration</NavLink>}
                <div className="nav-user-actions">
                  <NavLink to="/tableau-de-bord" className="nav-profil-link">
                    <NavAvatar user={user} />
                    <span>{user.nom.split(' ')[0]}</span>
                  </NavLink>
                  <NavLink to="/nouvelle-annonce" className="btn btn-or btn-sm">+ Publier</NavLink>
                  <button className="btn btn-ghost btn-sm" onClick={handleDeconnexion}>Déconnexion</button>
                </div>
              </>
            ) : (
              <>
                <NavLink to="/connexion" className="nav-hide-mobile">Connexion</NavLink>
                <NavLink to="/inscription" className="btn btn-primary btn-sm nav-hide-mobile">S'inscrire</NavLink>
              </>
            )}
          </div>
        </div>
      </nav>

      <nav className="mobile-app-nav" aria-label="Navigation mobile">
        <NavLink to="/" end>
          <MobileIcon type="home" />
          <span>Accueil</span>
        </NavLink>
        <NavLink to="/besoins">
          <MobileIcon type="needs" />
          <span>Demandes</span>
        </NavLink>
        {user ? (
          <>
            <NavLink to="/nouvelle-annonce" className="mobile-app-nav-main">
              <MobileIcon type="plus" />
              <span>Publier</span>
            </NavLink>
            <NavLink to="/tableau-de-bord">
              <MobileIcon type="user" />
              <span>Espace</span>
            </NavLink>
            {user.role === 'admin' ? (
              <NavLink to="/admin">
                <MobileIcon type="menu" />
                <span>Admin</span>
              </NavLink>
            ) : (
              <NavLink to="/tarifs">
                <MobileIcon type="menu" />
                <span>Tarifs</span>
              </NavLink>
            )}
          </>
        ) : (
          <>
            <NavLink to="/tarifs">
              <MobileIcon type="menu" />
              <span>Tarifs</span>
            </NavLink>
            <NavLink to="/connexion">
              <MobileIcon type="login" />
              <span>Connexion</span>
            </NavLink>
            <NavLink to="/inscription" className="mobile-app-nav-main">
              <MobileIcon type="register" />
              <span>Inscrire</span>
            </NavLink>
          </>
        )}
      </nav>
    </>
  );
}
